import {
  Button,
  NavBar,
  Icon,
  Toast,
  Tabs,
  WhiteSpace,
  SearchBar,
} from "antd-mobile";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../util/axios";
const JixiaoList = styled.div`
  .month {
    height: "250px";
    background-color: "#fff";
    padding: 10px 20px 10px 20px;
  }
  .month p {
    border-bottom: 1px solid #d7d7d7;
    width: 100%;
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #555555;
  }
  .year {
    background-color: #fff;
    padding: 10px 20px 10px 20px;
  }
  .year ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .year li {
    border: 1px solid #d7d7d7;
    border-radius: 5px;
    width: 100%;
    padding: 0 10px 0 10px;
    margin-bottom: 10px;
  }
  .year p {
    display: flex;
    justify-content: space-between;
  }
`;
interface Array1 {
  money: number;
  examTime: string;
  result: string;
}
export default function Achievements() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
    rejectId?: string;
    userId?: string;
  }>({
    visible: false,
  });
  const history = useHistory();
  const tabs = [{ title: "月度绩效金额" }, { title: "月度绩效扣除金额" }];
  const [detailsList, setDetailsList] = useState<{ [key: string]: any }>({
    Value: "",
  });
  const [deductionList, setDeductionList] = useState<Array1[]>([]);
  useEffect(() => {
    let url = window.location.href; //获取请求进来的完整url
    // console.log(url)
    // let tstr = url.substring(url.indexOf('?') + 1).split('&');//先截取url的?后面的参数部分，在根据&分割成参数数组
    let tstr = url.substring(url.indexOf("=") + 1); //获取examTime
    // console.log(tstr);

    instance.get(`/oa/performance/getMonthPerformanceList`).then((resp) => {
      // console.log(resp);
      if (resp.data.Status === "1") {
        let data = resp.data.Data.data.find(
          (item: any) => item.examTime === tstr
        );
        console.log(data);
        setDetailsList(data);
      }
    });

    instance
      .get(`/oa/performance/getMonthDeductionList?month=` + tstr)
      .then((resp) => {
        console.log(resp);
        if (resp.data.Status === "1") {
          setDeductionList(resp.data.Data.data);
        }
      });
  }, []);
  return (
    <>
      <JixiaoList>
        <div className="body">
          <NavBar
            className="orderNavBar"
            icon={
              <Icon
                type="left"
                onClick={() => {
                  history.push(`/hr/myquery`);
                }}
              />
            }
          >
            详情
          </NavBar>
          <WhiteSpace />
          <Tabs tabs={tabs} initialPage={"t2"}>
            {/* 月度绩效金额 */}
            <div className="month">
              {
                <>
                  <p>
                    <span>绩效(元)：</span>
                    <span>{detailsList.salaryPerformance}</span>
                  </p>
                  <p>
                    <span>讲课费和稿酬(元)：</span>
                    <span>{detailsList.teachFee}</span>
                  </p>
                  <p>
                    <span>其他(元)：</span>
                    <span>{detailsList.elseFee}</span>
                  </p>
                  <p>
                    <span>应发绩效(元)：</span>
                    <span>{detailsList.shouldPerformance}</span>
                  </p>
                  <p>
                    <span>扣个税(元)：</span>
                    <span>{detailsList.taxPersonal}</span>
                  </p>
                  <p>
                    <span>实发绩效(元)：</span>
                    <span>{detailsList.actualPerformance}</span>
                  </p>
                </>
              }
            </div>
            {/* 月度绩效扣除金额 */}
            <div
              style={{
                backgroundColor: "#fff",
                padding: "10px 20px 10px 20px",
              }}
              className="year"
            >
              <ul>
                {deductionList.map((item) => (
                  <li>
                    <p>
                      <span>绩效扣除月份：</span>
                      <span>{item.examTime}</span>
                    </p>
                    <p>
                      <span>扣除原因：</span>
                      <span>{item.result}</span>
                    </p>
                    <p>
                      <span>扣除金额(元)：</span>
                      <span>{item.money}</span>
                    </p>
                  </li>
                ))}
                {deductionList.length === 0 && (
                  <div style={{ textAlign: "center", marginTop: 10 }}>
                    <span>暂无扣除数据</span>
                  </div>
                )}
              </ul>
            </div>
          </Tabs>
        </div>
      </JixiaoList>
    </>
  );
}
